import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { Reveal, Lines, SectionTag } from "../site/Motion";

const POINTS = [
  { n: "01", title: "Linea robotizzata", text: "Le scocche MONOQ prendono forma su una linea automatizzata con standard di processo automobilistici." },
  { n: "02", title: "Controlli dimensionali", text: "Ogni scocca viene verificata nelle tolleranze prima di passare alla fase successiva." },
  { n: "03", title: "Standard automotive", text: "Acciaio e alluminio lavorati con le stesse discipline di produzione delle auto che abitano la città." },
];

export function Costruzione() {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="costruzione" data-testid="costruzione-section" ref={ref} className="relative overflow-hidden border-t border-white/10 bg-ink py-28 sm:py-40">
      <div className="mx-auto max-w-[1600px] px-5 sm:px-10">
        <SectionTag index="07" label="Costruzione" />
        <h2 className="mt-10 font-display font-extrabold uppercase leading-[0.92] tracking-tight">
          <Lines lines={["Precision,", "assembled."]} stagger={0.14} className="text-4xl text-white sm:text-6xl lg:text-7xl" />
        </h2>
        <Reveal delay={0.25}>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-zinc-400">
            SWAPA non nasce in un capannone qualsiasi. Nasce su una linea dove robot e
            controlli dimensionali trattano ogni monoscocca come quella di un'automobile.
          </p>
        </Reveal>

        <Reveal y={70} className="mt-16">
          <div className="relative overflow-hidden border border-white/10">
            <motion.img
              src="/assets/production-line.webp"
              alt="Linea di produzione robotizzata con scocca in lavorazione"
              className="aspect-[16/9] w-full object-cover sm:aspect-[21/9]"
              style={reduce ? {} : { y: imgY, scale: 1.12 }}
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/20" aria-hidden="true" />
            <p className="absolute bottom-5 left-5 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-300">
              Linea di produzione — scocca MONOQ™
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid gap-10 sm:grid-cols-3">
          {POINTS.map((p, i) => (
            <Reveal key={p.n} delay={i * 0.12} className="border-l border-white/10 pl-6 transition-colors duration-500 hover:border-swapa-yellow">
              <span className="font-mono text-xs text-swapa-yellow">{p.n} /</span>
              <h3 className="mt-2 font-display text-lg font-bold uppercase tracking-tight text-white">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-zinc-400">{p.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
